import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import HtlResRoomList from "./HtlResRoomList";
import HtlSalesPlanOffres from "./HtlSalesPlanOffres";
//import HtlAgnQuota from "./HtlAgnQuota";
//import HtlAgnGuarantee from "./HtlAgnGuarantee";
//import HtlAgnFreeRooms from "./HtlAgnFreeRooms";
import HtlSalesPlanCalc from "./HtlSalesPlanCalc";
import { Checkbox } from 'primereact/checkbox';
import { Timeline } from 'primereact/timeline';


import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $currentLocale: String
    $resMidId: Int

  ) {
    tbl_rez_mid(
   
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        rez_mid_id: { _eq: $resMidId }
      }
    ) {
      firm_main_code
      firm_sub_code
      firm_sub_name {
        firm_sub_name
      }
      get_main_firm_name_k {
        firm_main_name_n
      }
      firm_main_code_k
      firm_sub_code_k
      firm_sub_name_k {
        firm_sub_name_n
      }
      rez_mid_id
      rez_top_id
      acc_sub_code_k
      get_acc_sub_name_k {
        dpr_sub_name
      }
      voucher_no
      cont_id
      rez_date
      sty_start_date
      sty_end_date
      dpr_main_code
      dpr_sub_code
      dpr_main_code_k
      dpr_sub_code_k
      rez_type
      source_type
      status
      accmom_room
      accom_guest
      get_res_status(where: { lang: { _eq: $currentLocale } }) {
        name
        lang
        type
      }
   
      get_res_type_name(where: { lang: { _eq: $currentLocale } }) {
        name
        lang
        type
      }
    }
  }
`;

const GET_FIRM_MAIN_COOP = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
  ) {
    tbl_firm_main_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_main_name_n
      firm_main_type_n
      int_ID
    }
  }
`;






const GET_RBTYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_RETYPE = gql`
  query MyQuery($rttype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $rttype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_SOURCE = gql`
  query MyQuery($source: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $source },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_CUR = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_CONT_PRC = gql`
  query MyQuery(
    $firmMainCode: String
    $firmSubCode: String 
    $firmMainCodeK: String
    $firmSubCodeK: String
  ) {
    tbl_cont_prn(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        firm_main_code_k: { _eq: $firmMainCodeK },
        firm_sub_code_k: { _eq: $firmSubCodeK },
        active: { _eq: true },
      }
    ) {
      id_seq
      cont_type
      active
      currency
      start_date
      end_date
      cont_desc
    }
  }
`;

const GET_PRICE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;

const GET_MAIN_FIRM = gql`
  query MyQuery($firmMainCode: String!, $firmMainType: String) {
    tbl_firm_main(
      where: {
        firm_code: { _eq: $firmMainCode }
       
      }
    ) {
      firm_code
      firm_name
      firm_type
      ent_ID
    }
  }
`;

const GET_SUB_FIRM = gql`
  query MyQuery($firmMainCode: String!, $firmSubCode: String) {
    tbl_firm_sub(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
       
      }
    ) {
      firm_main_code
      firm_sub_code
      firm_sub_name
      int_ID
    }
  }
`;

const GET_MAIN_DPR_M = gql`
  query MyQuery($firmMainCode: String!, $firmSubCode: String) {
    tbl_dpr_main(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
       
      }
    ) {
      firm_main_code
      firm_sub_code
      dpr_main_code
      dpr_main_name
    }
  }
`;

const GET_MAIN_DPR_MK = gql`
  query MyQuery(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
    $firmSubCodeK: String)
     {
      tbl_dpr_main_coop(
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode },
        own_firm_sub_code: { _eq: $ownFirmSubCode },
        own_firm_sub_type: { _eq: $ownFirmSubType },
        firm_main_code_n: { _eq: $firmMainCodeK },
        firm_sub_code_n: { _eq: $firmSubCodeK },
       
      }
    ) {
      dpr_main_code_n
      dpr_main_name_n
      dpr_int_ID
      
    }
  }
`;

const GET_SUB_DPR_K = gql`
  query MyQuery(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
    $firmSubCodeK: String
    $dprMainMK: String!)
     {
      tbl_dpr_sub_coop(
      where: {
        own_firm_code: { _eq: $ownFirmMainCode },
        own_firm_sub_code: { _eq: $ownFirmSubCode },
        own_firm_sub_type: { _eq: $ownFirmSubType },
        firm_main_code_n: { _eq: $firmMainCodeK },
        firm_sub_code_n: { _eq: $firmSubCodeK },
        dpr_main_code_n: { _eq: $dprMainMK },
       
      }
    ) {
      dpr_sub_code_n
      dpr_sub_name_n
      dpr_sub_n_int_ID
      
    }
  }
`;

const GET_FIRM_MAIN_COOP_K = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
  ) {
    tbl_firm_main_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        firm_main_code_n: { _eq: $firmMainCodeK }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_main_name_n
      firm_main_type_n
      int_ID
    }
  }
`;

const GET_FIRM_SUB_COOP_K = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    $firmMainCodeK: String
  ) {
    tbl_firm_sub_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        firm_main_code_n: { _eq: $firmMainCodeK }
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_sub_code_n
      firm_sub_name_n
      firm_sub_type_n
      int_ID
    }
  }
`;

const GET_FIRM_SUB_COOP_K2 = gql`
  query GetFilteredFirms(
    $ownFirmMainCode: String
    $ownFirmSubCode: String
    $ownFirmSubType: String
    
  ) {
    tbl_firm_sub_coop(order_by: { firm_main_code_n: asc },
      where: {
        own_firm_main_code: { _eq: $ownFirmMainCode }
        own_firm_sub_code: { _eq: $ownFirmSubCode }
        own_firm_sub_type: { _eq: $ownFirmSubType }
        
      }
    ) {
      own_firm_main_code
      own_firm_sub_code
      own_firm_sub_type
      firm_main_code_n
      firm_sub_code_n
      firm_sub_name_n
      firm_sub_type_n
      int_ID
    }
  }
`;

const GET_SUB_DPR_M = gql`
  query MyQuery($firmMainCode: String!, $firmSubCode: String, $dprMainM: String) {
    tbl_dpr_sub(
      where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        dpr_main_code: { _eq: $dprMainM },
       
      }
    ) {
      firm_main_code
      firm_sub_code
      dpr_main_code
      dpr_sub_code
      dpr_sub_name
    }
  }
`;





const UPDATE_CONT = gql`
mutation UpdateContract(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $firmMainCodeK: String
  $firmSubCodeK: String
 
  $dprMainM: String
  $dprSubM: String
  $dprMainMK: String
  $dprSubMK: String
  $restDate: date
  $startDate: date
  $endDate: date
  $contStatus: String
  $resType: String
  $contType: String
  $sourceType: String
  $resContId: Int
  $resMidId: Int
) {
  update_tbl_rez_mid(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      rez_mid_id: { _eq: $contIdSeq }
    },
    _set: {
    
      dpr_main_code: $dprMainM,
      dpr_sub_code: $dprSubM,
      dpr_main_code_k: $dprMainMK,
      dpr_sub_code_k: $dprSubMK,
      firm_main_code_k: $firmMainCodeK,
      firm_sub_code_k: $firmSubCodeK,
      rez_date: $restDate,
      sty_start_date: $startDate,
      sty_end_date: $endDate,
      status: $contStatus,
      rez_type: $resType,
      cont_type: $contType,
      source_type: $sourceType,
      cont_id: $resContId,

    
    }
  ) {
    affected_rows
  }
}
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const INSERT_CONT = gql`
mutation InsertContract(
  $contIdSeq: Int
  $firmMainCode: String
  $firmSubCode: String
  $firmMainCodeK: String
  $firmSubCodeK: String
 
  $dprMainM: String
  $dprSubM: String
  $dprMainMK: String
  $dprSubMK: String
  $restDate: date
  $startDate: date
  $endDate: date
  $contStatus: String
  $resType: String
  $contType: String
  $sourceType: String
  $resContId: Int
  $resMidId: Int
  $resTopId: Int
 
  ) {
    insert_tbl_rez_mid(
      objects: {  
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        rez_mid_id: $contIdSeq,
        rez_top_id: $resTopId,
   
        dpr_main_code: $dprMainM,
        dpr_sub_code: $dprSubM,
        dpr_main_code_k: $dprMainMK,
        dpr_sub_code_k: $dprSubMK,
        firm_main_code_k: $firmMainCodeK,
        firm_sub_code_k: $firmSubCodeK,
        rez_date: $restDate,
        sty_start_date: $startDate,
        sty_end_date: $endDate,
        status: $contStatus,
        rez_type: $resType,
        cont_type: $contType,
        source_type: $sourceType,
        cont_id: $resContId,

  
      }
    ) {
      affected_rows
    }
  }
`;


const GET_ROOMS = gql`
  query GetRooms(
    $firmMainCode: String, 
    $firmSubCode: String,
    $contIdSeq: Int
  ) {
    tbl_rez_rooms(
      where: {
        firm_main_code: { _eq: $firmMainCode }, 
        firm_sub_code: { _eq: $firmSubCode },
        rez_mid_id: { _eq: $contIdSeq },
        
      },
      order_by: { rez_room_id: asc } 
    ) {   
      rez_mid_id
      rez_room_id
      rez_top_id
      folio_id
      room_class
      room_type
      person_chl
      person_adl
      room_sub_total
      get_room_name {
        r_type_name
      }
      arrival_date
      departure_date

    }
  }
`;

const GET_REZ_ACC_PRE_FOL = gql`
query MyQuery(
    $resMidId: Int
  
    $ownFirmCode: String
    $ownFirmSubCode: String
  

    ) {
      tbl_rez_room_dtl(where: {
            rez_mid_id: {_eq: $resMidId}
            
          
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       room_dtl_id
       get_room_folio_price_calc(where: {        
        red_sup: { _eq: "R" } 
      }) {
        code
        value
        type
      }
       date
       room_code
       product_code
       type
       quantity
       unit
       price
       price_base
       currency
       date
       debit
       credit
       firm_main_code
       firm_sub_code

      
    

  } 
  
}
`;




const HtlResAboutDltInfo = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode8, setVarCode8 } = useContext(ThemeContext);
  const { varCode4, setVarCode4 } = useContext(ThemeContext);
  const { users } = useContext(UserContext);
  const { rez_mid_id } = useParams();
  //setVarCode4(id_seq);
  
  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(0);
  const [activeTabR, setActiveTabR] = useState(0);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };

  const handleTabChangeR = (index) => {
    setActiveTabR(index);
  };


  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, resMidId: rez_mid_id, currentLocale: currentLocale },
  });



  const ownFirmMainCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

 

 
  const [UpdateContract] = useMutation(UPDATE_CONT);
  const [InsertContract] = useMutation(INSERT_CONT);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 

  const firmData = data && data.tbl_rez_mid ? data.tbl_rez_mid[0] : null;
  console.log(firmData);

  
  

  
 
  const [rTypeName, setRTypeName] = useState(
    firmData ? firmData.firm_sub_name_k[0].firm_sub_name_n : ""
  );
  const [firmSubName, setFirmSubName] = useState(
    firmData ? firmData.firm_sub_name[0].firm_sub_name : ""
  );

  const [mFIntId, setMFIntId] = useState(
    firmData ? firmData.firm_sub_name[0].int_ID : ""
  );

//  const [contTypeName, setContTypeName] = useState(
//    firmData ? firmData.get_cont_type_name[0].name : "" );

    const [firmMainNameK, setFirmMainNameK] = useState(
    firmData ? firmData.get_main_firm_name_k[0].firm_main_name_n : "" );
  
  const [rIntId, setRIntId] = useState(firmData ? firmData.int_ID : "");
  

  const [searchTerm, setSearchTerm] = useState("");
  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
const [first1, setFirst1] = useState(0);
  
  const [firmMainCodeK, setfirmMainCodeK] = useState(firmData ? firmData.firm_main_code_k : "");
  const [firmSubCodeM, setfirmSubCodeM] = useState(firmData ? firmData.firm_sub_code :"");
  const [firmSubCodeK, seFirmSubCodeK] = useState(firmData ? firmData.firm_sub_code_k : ""); 

  const [contIdSeqq, setContIdSeqq] = useState(0);
  
  const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.res_mid_id :"");
  const [contIdSeqK, setContIdSeqK] = useState(firmData ? firmData.id_seq_k: "");
  
  
  
  const [saveArr, setSaveArr] = useState(firmData ? firmData.save_arr: 1);
  const [contStatusK, setContStatusK] = useState(firmData ? firmData.k_status: "");
  const [active, setActive] = useState(firmData ? firmData.active : false);
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.sty_start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.sty_end_date) : new Date());
  const [currency, setCurrency] = useState(firmData ? firmData.currency: "");
  const [market, setMarket] = useState(firmData ? firmData.marketing: "");
  const [contGroup, setContGroup] = useState(firmData ? firmData.cont_group: "");
  
  
  const [dprMainM, setDprMainM] = useState(firmData ? firmData.dpr_main_code: "");
  const [dprSubM, setDprSubM] = useState(firmData ? firmData.dpr_sub_code: "");
  const [dprMainMK, setDprMainMK] = useState(firmData ? firmData.dpr_main_code_k: "");
  const [dprSubMK, setDprSubMK] = useState(firmData ? firmData.dpr_sub_code_k: "");
  const [kFIntId, setKFIntId] = useState(firmData ? firmData.k_int_ID: "");
  

  const [restDate, setResDate] = useState(firmData ? new Date(firmData.rez_date): new Date());
  const [contStatus, setContStatus] = useState(firmData ? firmData.status: "PRPR");
  const [resType, setResType] = useState(firmData ? firmData.rez_type: "INCR");
  const [contType, setContType] = useState(firmData ? firmData.cont_type : "HSP");
  const [sourceType, setSourceType] = useState(firmData ? firmData.source_type : "");
  const [resContId, setResContId] = useState(firmData ? firmData.cont_id : "");
  const [resTopId, setResTopId] = useState(firmData ? firmData.rez_top_id : "");
  const [resAccomRoom, setResAccomRoom] = useState(firmData ? firmData.accmom_room : "");
  const [resAccomGuest, setResAccomGuest] = useState(firmData ? firmData.accom_guest : "");

  const [resGuestId, setResGuestId] = useState(firmData ? firmData.guest_id : 0); 
  const [profileId, setProfileId] = useState(firmData ? firmData.profile_id : 0); 
  const [guestTitle, setGuestTitle] = useState(firmData ? firmData.title : ""); 


  const genderOptions = [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }];
  const nationalityOptions = [{ label: 'Bangladeshi', value: 'bangladeshi' }];
  const guestCategoryOptions = [{ label: 'VIP', value: 'vip' }];
  const idTypeOptions = [{ label: 'National ID', value: 'nid' }];
  const paymentMethodOptions = [{ label: 'Credit Card', value: 'creditcard' }];
  const purposeOptions = [{ label: 'Guest', value: 'guest' }];
  const typeOptions = [{ label: 'Cash', value: 'cash' }];
  const arrivalModeOptions = [{ label: 'By Air', value: 'byair' }];

  const events = [
    { status: '', date: [startDate].map(date => date.toLocaleDateString('tr-TR')), icon: 'pi pi-shopping-cart', color: '#9C27B0', image: 'game-controller.jpg' },
    { status: '', date: [endDate].map(date => date.toLocaleDateString('tr-TR')), icon: 'pi pi-cog', color: '#673AB7' },
   
];

  
  

 
  

  
  
  const convertDateFormat = (inputDate) => {
    const [year, month, day] = inputDate.split("-");
    return `${month}/${day}/${year}`;
  };
 

  //const [endDate, setEndDate] = useState(firmData ? firmData.end_date: "");
  //const formattedDate = incomingDate.split("-").reverse().join("/");

  

  
  
  
  


  
  
  const close_form = messages[currentLocale].close_form;
  
  const typerec = messages[currentLocale].typerec;
  
  const updaterec = messages[currentLocale].updaterec;
  const int_id = messages[currentLocale].int_id;
  const cont_grp_select_holder = messages[currentLocale].cont_grp_select_holder;
  const sub_code = messages[currentLocale].sub_code;
  const select_a_bed_type = messages[currentLocale].select_a_bed_type;
  
 
  const cont_group_title = messages[currentLocale].cont_group_title;
  
  const managing_hotel = messages[currentLocale].managing_hotel;
  
  const room_class_tab = messages[currentLocale].room_class_tab;
  const cont_type_title = messages[currentLocale].cont_type_title;
  const select_a_agency = messages[currentLocale].select_a_agency;
  
  const cont_grp_code_title = messages[currentLocale].cont_grp_code_title;
  const cont_new_button = messages[currentLocale].cont_new_button;
  const market_code_title = messages[currentLocale].market_code_title;
  const market_title = messages[currentLocale].market_title;
  const select_market_holder = messages[currentLocale].select_market_holder;
  const currency_title = messages[currentLocale].currency_title;
  const currency_code_title = messages[currentLocale].currency_code_title;
  const firm_sub_name = messages[currentLocale].firm_sub_name;
  const integration_id_title = messages[currentLocale].integration_id_title;
  const main_department_code = messages[currentLocale].main_department_code;
  const main_department_name = messages[currentLocale].main_department_name;
  const sub_department_code = messages[currentLocale].sub_department_code;
  const sub_department_name = messages[currentLocale].sub_department_name;

  

  const administrator = messages[currentLocale].administrator;
  const dashboard = messages[currentLocale].dashboard
  const firm_update_successfully = messages[currentLocale].firm_update_successfully;
  const select_a_department_holder = messages[currentLocale].select_a_department_holder;

  const position = messages[currentLocale].position;
  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
  const placerec = messages[currentLocale].placerec;
  
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const detail = messages[currentLocale].detail;

  const cont_detail_tab = messages[currentLocale].cont_detail_tab;
  const cont_rules_tab = messages[currentLocale].cont_rules_tab;
  const cont_season_tab = messages[currentLocale].cont_season_tab;
  const cont_reductions_tab = messages[currentLocale].cont_reductions_tab;
  const cont_guarantee_tab = messages[currentLocale].cont_guarantee_tab;
  const cont_special_con_tab = messages[currentLocale].cont_special_con_tab;
  const cont_offers_tab = messages[currentLocale].cont_offers_tab;
  const cont_pax_calcutate_tab = messages[currentLocale].cont_pax_calcutate_tab;

  const cont_management_title = messages[currentLocale].cont_management_title;
  const sales_office_title = messages[currentLocale].sales_office_title;
  const cont_detail_title = messages[currentLocale].cont_detail_title;




 

  



  


  
 

  const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_RBTYPE, {
    variables: { drbtype: "RSTS", lang: currentLocale},
  });

  const { loading: rtLoading, error: rtError, data: rtData } = useQuery(GET_RETYPE, {
    variables: { rttype: "BOOK", lang: currentLocale},
  });

  const { loading: sourceLoading, error: sourceError, data: sourceData } = useQuery(GET_SOURCE, {
    variables: { source: "CUTYP", lang: currentLocale},
  });

  const { loading: curLoading, error: curError, data: curData } = useQuery(GET_CUR, {
    variables: { drbtype: "CUR", lang: currentLocale},
  });

  const { loading: marLoading, error: marError, data: marData } = useQuery(GET_CONT_PRC, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, firmMainCodeK: firmMainCodeK, firmSubCodeK},
  });

  const { loading: firmmLoading, error: firmmError, data: firmmData } = useQuery(GET_MAIN_FIRM, {
    variables: { firmMainCode: firmMainCode},
  });

  const { loading: firmsLoading, error: firmsError, data: firmsData } = useQuery(GET_SUB_FIRM, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode},
  });

  const { loading: dprmmLoading, error: dprmmError, data: dprmmData } = useQuery(GET_MAIN_DPR_M, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode},
  });

  const { loading: dprmmkLoading, error: dprmmkError, data: dprmmkData } = useQuery(GET_MAIN_DPR_MK, {
    variables: {  ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK, firmSubCodeK: firmSubCodeK},
  });

  

  const { loading: dprsmLoading, error: dprsmError, data: dprsmData } = useQuery(GET_SUB_DPR_M, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, dprMainM: dprMainM},
  });

  const { loading: dprsmkLoading, error: dprsmkError, data: dprsmkData } = useQuery(GET_SUB_DPR_K, {
    variables: {  ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK, firmSubCodeK: firmSubCodeK, dprMainMK: dprMainMK},
  });

  const { loading: fmckloading, error: fmclerror, data: fmckData } = useQuery(GET_FIRM_MAIN_COOP_K, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK},
  });

  const { loading: fsckloading, error: fsclerror, data: fsckData } = useQuery(GET_FIRM_SUB_COOP_K, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType, firmMainCodeK: firmMainCodeK},
  });

  //sub code for serach form table

  const { loading: fsck2loading, error: fsc2lerror, data: fsck2Data } = useQuery(GET_FIRM_SUB_COOP_K2, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType},
  });




  const { loading: fmcloading, error: fmcerror, data: fmcdata } = useQuery(GET_FIRM_MAIN_COOP, {
    variables: { ownFirmMainCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode, ownFirmSubType: ownFirmSubType},
  });

  const { loading: loadingRuleSub, error: perRuleSubError, data: perRuleSubData, refetch: refetchRuleSub } = useQuery(GET_ROOMS, {
    variables: { firmMainCode: firmMainCode, firmSubCode: firmSubCode, contIdSeq: contIdSeq },
  });

  const firmData2 = perRuleSubData && perRuleSubData.tbl_rez_rooms;


  
  const filteredFirms = fmcdata && fmcdata.tbl_firm_main_coop
  ? fmcdata.tbl_firm_main_coop.filter((firm) =>
      firm.firm_main_name_n.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];

  const filteredSubFirms = fsck2Data && fsck2Data.tbl_firm_sub_coop
  ? fsck2Data.tbl_firm_sub_coop.filter((firm) =>
      firm.firm_sub_name_n.toLowerCase().includes(searchTerm.toLowerCase())
    )
  : [];

  
  

  const roomClassSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const resTypeSelect = rtData && rtData.tbl_gnl_def
  ? rtData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const sourceTypeSelect = sourceData && sourceData.tbl_gnl_def
  ? sourceData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  const currencySelectItems = curData && curData.tbl_gnl_def
  ? curData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];



  const contPriceSelectItems = marData && marData.tbl_cont_prn
  ? marData.tbl_cont_prn.map(item => ({
      label: (
        <div>
          <div>{item.cont_desc}</div>
          <div>Start Date: {new Date(item.start_date).toLocaleDateString('en-GB')}</div>
  <div>End Date: {new Date(item.end_date).toLocaleDateString('en-GB')}</div>
        </div>
      ),
      value: item.id_seq,
    }))
  : [];

  const firmMainItems = firmmData && firmmData.tbl_firm_main
  ? firmmData.tbl_firm_main.map(item => ({
      label: item.firm_name,
      value: item.firm_code,
      name: item.firm_name, 
    }))
  : [];

  const firmSubItems = firmsData && firmsData.tbl_firm_sub
  ? firmsData.tbl_firm_sub.map(item => ({
      label: item.firm_sub_name,
      value: item.firm_sub_code,
      name: item.firm_sub_name, 
    }))
  : [];

  const firmSubItems2 = firmsData && firmsData.tbl_firm_sub
  ? firmsData.tbl_firm_sub.map(item => ({
      label: item.int_ID,
      value: item.firm_sub_code,
      name: item.int_ID, 
    }))
  : [];

  const dprMainMItems = dprmmData && dprmmData.tbl_dpr_main
  ? dprmmData.tbl_dpr_main.map(item => ({
      label: item.dpr_main_name,
      value: item.dpr_main_code,
      name: item.dpr_main_name, 
    }))
  : [];

  const dprMainMKItems = dprmmkData && dprmmkData.tbl_dpr_main_coop
  ? dprmmkData.tbl_dpr_main_coop.map(item => ({
      label: item.dpr_main_name_n,
      value: item.dpr_main_code_n,
      name: item.dpr_main_name_n, 
    }))
  : [];

  const dprSubKItems = dprsmkData && dprsmkData.tbl_dpr_sub_coop
  ? dprsmkData.tbl_dpr_sub_coop.map(item => ({
      label: item.dpr_sub_name_n,
      value: item.dpr_sub_code_n,
      name: item.dpr_sub_name_n, 
    }))
  : [];



  const dprSubMItems = dprsmData && dprsmData.tbl_dpr_sub
  ? dprsmData.tbl_dpr_sub.map(item => ({
      label: item.dpr_sub_name,
      value: item.dpr_sub_code,
      name: item.dpr_sub_name, 
    }))
  : [];

  const firmMainItemsK = fmckData && fmckData.tbl_firm_main_coop
  ? fmckData.tbl_firm_main_coop.map(item => ({
      label: item.firm_main_name_n,
      value: item.firm_main_code_n,
      name: item.firm_main_name_n, 
    }))
  : [];

  const firmSubItemsK = fsckData && fsckData.tbl_firm_sub_coop
  ? fsckData.tbl_firm_sub_coop.map(item => ({
      label: item.firm_sub_name_n,
      value: item.firm_sub_code_n,
      name: item.firm_sub_name_n,
      intIdK: item.int_ID, 
    }))
  : [];

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);

  


  
  const handleChange = (setter) => (e) => {
    setter(e.target.value);
};

const [totalAdl, setTotalAdl] = useState(0);
  const [totalChl, setTotalChl] = useState(0);

  useEffect(() => {
    if (firmData2 && Array.isArray(firmData2)) {
      let adlSum = 0;
      let chlSum = 0;

      firmData2.forEach((data) => {
        adlSum += data.person_adl || 0;
        chlSum += data.person_chl || 0;
      });

      setTotalAdl(adlSum);
      setTotalChl(chlSum);
    }
  }, [firmData2]);
  


  useEffect(() => {
    if (firmSubCodeK) {
      const selectedFirmSub = firmSubItemsK.find(item => item.value === firmSubCodeK);
      if (selectedFirmSub) {
        setKFIntId("");
        setKFIntId(selectedFirmSub.intIdK);
      }
    }
  }, [firmSubCodeK, firmSubItemsK]);

  useEffect(() => {
    if (firmData && firmData.dpr_main_code !== dprMainM) {
      setDprSubM("");
    }
  }, [firmData, dprMainM]);

 


  const handleUpdateIdSeq2 = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'MFIRM', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
     setResTopId(updatedIdSeq);
     handleUpdateIdSeq();
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };
 

  const handleUpdateIdSeq = async () => {
    const requiredFields = [ 'firmSubCode', 'firmMainCode',
                           'firmMainCodeK','firmMainCodeK' ,  'dprMainM',
                           'dprSubM', 'dprMainMK', 'dprSubMK' ]; // Required fiels
    const customFieldNames = {
      
      firmSubCode: sub_code,
      firmMainCode: firm_code,      
      firmMainCodeK: sub_code,
     
      dprMainM: main_department_code,
      dprSubM: sub_department_code,
      dprMainMK: main_department_code,
      dprSubMK: sub_department_code,


      






    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        
        
        setContIdSeq(updatedIdSeq); 
        setContIdSeqq(updatedIdSeq);
        
        setVarCode4(updatedIdSeq);
        
        console.log(contIdSeq);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Lütfen şu alanları doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };
  
  const validateForm = (requiredFields, customFieldNames) => {
    // Tüm gerekli alanları kontrol et
    for (const field of requiredFields) {
      if (!eval(field)) {
        return false;
      }
    }
  
    return true;
  };
  
  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (contIdSeq !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
      handleinsert();  
    
    }
  }, [contIdSeq, setContIdSeq]);

 

  useEffect(() => {
    if (firmData) {
     
      seFirmSubCodeK(firmData.firm_sub_code_k);
      setRTypeName(firmData.firm_sub_name_k[0].firm_sub_name_n);
      setFirmSubName(firmData.firm_sub_name[0].firm_sub_name);
      
      setRIntId(firmData.int_ID);
      setActive(firmData.active);

      setContIdSeq(firmData.rez_mid_id);
      setVarCode4(firmData.rez_mid_id);
      setResTopId(firmData.rez_top_id);
      
      setContIdSeqK(firmData.id_seq_k);
      setfirmSubCodeM(firmData.firm_sub_code);
      setfirmMainCodeK(firmData.firm_main_code_k);
   //   setFirmMainNameK(firmData.get_main_firm_name_k[0].firm_main_name_n);
      setSaveArr(firmData.save_arr);
      

      setContType(firmData.cont_type);
      setResType(firmData.rez_type);
   //   setContTypeName(firmData.get_cont_type_name[0].name);
      
      setContStatusK(firmData.k_status);
      setStartDate(new Date(firmData.start_date));
      setEndDate(new Date(firmData.end_date));
      setContGroup(firmData.cont_group);
      setMarket(firmData.marketing);
      setCurrency(firmData.currency);
      setMFIntId(firmData.firm_sub_name[0].int_ID);
      setKFIntId(firmData.k_int_ID);
      setDprMainM(firmData.dpr_main_code);
      setDprSubM(firmData.dpr_sub_code);
      setDprMainMK(firmData.dpr_main_code_k);
      setDprSubMK(firmData.dpr_sub_code_k);
      setVarCode8(firmData.currency);

      setResDate(new Date(firmData.rez_date));
      setStartDate(new Date(firmData.sty_start_date));
      setEndDate(new Date(firmData.sty_end_date));
      setContStatus(firmData.status);
      setResType(firmData.rez_type);
      setSourceType(firmData.source_type);
      setResContId(firmData.cont_id);
      setResAccomRoom(firmData.accmom_room);
      setResAccomGuest(firmData.accom_guest);

 
    }
  }, [firmData]);





  const { loading: loodinpreaccfol, error:errorpreaccfol, data: datapreaccfol, refetch: refechpreaccfol } = useQuery(GET_REZ_ACC_PRE_FOL, {
    variables: { resMidId: contIdSeq, ownFirmCode: ownFirmMainCode, ownFirmSubCode: ownFirmSubCode },
  });

  const firmData6 = datapreaccfol && datapreaccfol.tbl_rez_room_dtl;


  const [totals, setTotals] = useState({ basePrice: 0, discounts: 0, taxes: 0, additionalTaxes: 0, finalPrice: 0 });

  useEffect(() => {
    if (datapreaccfol && datapreaccfol.tbl_rez_room_dtl) {
      let basePrice = 0;
      let discounts = 0;
      let taxes = 0;
      let additionalTaxes = 0;
      let finalPrice = 0;
  
      datapreaccfol.tbl_rez_room_dtl.forEach(record => {
        let updatedPrice = record.price_base || record.price;
        let recordTaxes = 0;
        let recordDiscounts = 0;
        let recordAdditionalTaxes = 0;
  
        // Apply TAX discounts first
        record.get_room_folio_price_calc
          .filter(discount => discount.type === 'TAX')
          .forEach(discount => {
            const discountAmount = updatedPrice * (discount.value  / (100 + discount.value));
            
            updatedPrice -= discountAmount;
            recordTaxes += discountAmount;
          });
  
        // Apply other discounts
        record.get_room_folio_price_calc
          .filter(discount => discount.type !== 'TAX')
          .forEach(discount => {
            const discountAmount = updatedPrice * (discount.value / 100);
            updatedPrice -= discountAmount;
            recordDiscounts += discountAmount;
          });
  
        // Calculate additional taxes on discounted price
        record.get_room_folio_price_calc
          .filter(discount => discount.type === 'TAX') // Assuming 'ADDITIONAL_TAX' is used for additional tax type
          .forEach(discount => {
            const additionalTaxAmount = updatedPrice * (discount.value / 100);
            updatedPrice += additionalTaxAmount; // Add the tax back to the updated price
            recordAdditionalTaxes += additionalTaxAmount;
          });
  
        basePrice += record.price_base || record.price;
        discounts += recordDiscounts;
        taxes += recordTaxes;
        additionalTaxes += recordAdditionalTaxes;
        finalPrice += updatedPrice;
      });
  
      setTotals({ basePrice, discounts, taxes, additionalTaxes, finalPrice });
    }
  }, [datapreaccfol]);


  useEffect(() => {
    refechpreaccfol();
  }, [datapreaccfol]);



  const actionTemplate = (rowData) => {
    const { firm_main_code_n, firm_main_name_n, int_ID } = rowData;
    
    setfirmMainCodeK(firm_main_code_n);
    
    refetch();
    
   
    return (
     
        <button
          type="button"
          title="Open details"
          className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
        >
          <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
            <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z"></path>
          </svg>
        </button>
        
    
      
    );
      };
  

  

  const handleUpdateCont = () => {
    UpdateContract({
      variables: {   
        contIdSeq: contIdSeq,
        
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        firmMainCodeK: firmMainCodeK,
        firmSubCodeK: firmSubCodeK,
      
    //    startDate: new Date(startDate).toLocaleDateString(),
   //     endDate: new Date(endDate).toLocaleDateString(),
    
      
        dprMainM: dprMainM,
        dprSubM: dprSubM,
        dprMainMK: dprMainMK,
        dprSubMK: dprSubMK,
        restDate: new Date(restDate).toLocaleDateString(),
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        contStatus: contStatus,
        resType: resType,
        contType: contType,
        sourceType: sourceType,
        resContId: resContId,


        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
        setVarCode8(currency);
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  const handleinsert = () => {
       InsertContract({
        variables: {
          contIdSeq: contIdSeq,
        
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        firmMainCodeK: firmMainCodeK,
        firmSubCodeK: firmSubCodeK,
      
    //    startDate: new Date(startDate).toLocaleDateString(),
   //     endDate: new Date(endDate).toLocaleDateString(),
    
      
        dprMainM: dprMainM,
        dprSubM: dprSubM,
        dprMainMK: dprMainMK,
        dprSubMK: dprSubMK,
        restDate: new Date(restDate).toLocaleDateString(),
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        contStatus: contStatus,
        resType: resType,
        contType: contType,
        sourceType: sourceType,
        resContId: resContId,
        resTopId: resTopId,
         
        },
      })
        .then(() => {
          window.alert("Contract insert successfully!");
          setVarCode4(contIdSeq);
         
          fetch();
          
        })
        .catch((error) => {
          console.error("Error insert Contract:", error);
        });
    };

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;



const handleClose = () => {
  refetch();
 
  // Sayfadan ayrılmadan önce verileri temizle
  // ...

  // Daha sonra sayfadan çıkış yap
  navigate(-1);
};






const items = [{ label: dashboard ,url: "/", target: '_self'},  { label: sales_office_title ,url:"/htl/sales-office/main" }, { label: cont_management_title ,url:"/htl/sales/price/htlagncont-list" }, { label: cont_detail_title }];

return (


    
<div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">

<div className="p-4">
      <div className="border rounded-md shadow-md p-4 bg-white">
        <div className="flex justify-between items-center border-b pb-2 mb-2">
          <h2 className="text-lg font-bold">Res. #: {contIdSeq}</h2>
          <div className="flex space-x-2">


        <div>
        <Dropdown
className="w-28 h-11 rounded-md" // Bu satır eklenmiştir
style={{ width: '100%' }}
dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
<path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
</svg>}
value={sourceType}
options={sourceTypeSelect}
onChange={(e) => setSourceType(e.value)}
placeholder={position}
/>
        </div>
        <div>
            <div className="h-11 w-full font-bold text-purple-900 pl-5 pr-5 rounded-md border p-2">
                {roomClassSelectItemsB.find(option => option.value === contStatus)?.label || position}
            </div>
            <input 
                type="hidden" 
                value={contStatus} 
                onChange={handleChange(setContStatus)} 
            />
        </div>
          </div>
        </div>
        

        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">

          <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTabS} onTabChange={(e) => handleTabChangeS(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Guest Information"}
            </span>
          }
          className="ml-5 flex"
        >
       
            <div className="grid grid-cols-5 mt-5 gap-4">
            <div className="col-span-1">

<label className="block font-bold mb-1">Title</label>
<Dropdown
      className="h-11  w-5 rounded-md" // Bu satır eklenmiştir
      style={{ width: '95%' }}
      dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
      <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
    </svg>}
      value={guestTitle}
     // options={guesttitletems}
      onChange={(e) => setGuestTitle(e.value)}
      placeholder={"Mr Etc."}
    />
</div>
              <div className="col-span-2">

                <label className="block w-10 font-bold mb-1">Name</label>
                <InputText className="w-full" placeholder="Mr." />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">{"Last Name"}</label>
                <InputText className="w-full" placeholder="First Name" />
              </div>
              
              <div className="col-span-1">
              <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-bold text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Profile Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={profileId}
    onChange={(e) => setProfileId(e.target.value)}
    readOnly
    />
                </div>
              </div>
              <div className="col-span-1 ">
              <button 
              onClick={() => setVisible2(true)} 
             className="cursor-pointer mt-10 flex items-center m-0 text-violet-700 hover:text-violet-400 "
             >
              <svg 
               className="w-6 h-6 text-gray-800 dark:text-white" 
               aria-hidden="true" 
               xmlns="http://www.w3.org/2000/svg" 
               fill="none" 
              viewBox="0 0 20 20"
                >
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
            </svg>
           </button>   
           </div>    

           <div className="col-span-1">
              <div className="w-1/8 p-inputtext-sm font-bold flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Code"}</label>
    <InputText className="w-full text-base" 
    id="username" value={profileId}
    onChange={(e) => setProfileId(e.target.value)}
    readOnly
    />
                </div>
              </div>

              <div className="col-span-1">
                <label className="block font-bold mb-1">Nationality</label>
                <Dropdown className="w-full" options={nationalityOptions} placeholder="Select a Nationality" />
              </div>

        
              <div className="col-span-2">
                <label className="block font-bold mb-1">Email</label>
                <InputText className="w-full" placeholder="name@gmail.com" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">Phone</label>
                <InputText className="w-full" placeholder="0123 456 789" />
              </div>
              <div className="col-span-1">
                <Button label="Profile" className="p-button-link mt-7 h-11" />
              </div>
            
            
            
              <div className="col-span-2">
                <label className="block font-bold mb-1">Guest Class</label>
                <Dropdown className="w-full" options={guestCategoryOptions} placeholder="Select a Category" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">Club Member</label>
                <Dropdown className="w-full" options={idTypeOptions} placeholder="Select an ID Type" />
              </div>
            
             
            </div>
         
        

      </TabPanel>

      <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 21 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Agency Information"}
            </span>
          }
          className="ml-5 flex"
        >
       
      <div>

      <div>

      <label className="block font-bold mt-3 mb-1">Firm</label>
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-1">
              <div>
            <div className="w-full rounded-md border p-2">
                {firmMainItemsK.find(option => option.value === firmMainCodeK)?.label || position}
            </div>
            <InputText 
                type="hidden" 
                value={firmMainCodeK} 
                onChange={handleChange(setfirmMainCodeK)} 
            />
        </div>
              </div>
             
              <div className="col-span-1">
              <div>
            <div className=" rounded-md border p-2">
                {firmMainItemsK.find(option => option.value === firmMainCodeK)?.label || position}
            </div>
            <InputText 
                type="hidden" 
                value={firmMainCodeK} 
                onChange={handleChange(setfirmMainCodeK)} 
            />
        </div>
        </div>

              
</div>

<label className="block font-bold mt-4 mb-1">Account </label>
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-1">
              <div>
            <div className=" rounded-md border p-2">
                {firmMainItemsK.find(option => option.value === firmMainCodeK)?.label || position}
            </div>
            <InputText 
                type="hidden" 
                value={firmMainCodeK} 
                onChange={handleChange(setfirmMainCodeK)} 
            />
        </div>
              </div>
             
              <div className="col-span-1">
              <div>
            <div className=" h-12 rounded-md border p-3">
                {firmMainItemsK.find(option => option.value === firmMainCodeK)?.label || position}
            </div>
            <InputText 
                type="hidden" 
                value={firmMainCodeK} 
                onChange={handleChange(setfirmMainCodeK)} 
            />
        </div>     
        </div>

</div>

<label className="block font-bold mt-4 mb-1">Department </label>
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-1">
              <div>
<Dropdown
className="h-11 w-24 rounded-md" // Bu satır eklenmiştir
style={{ width: '100%' }}
dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
<path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
</svg>}
value={dprMainMK}
options={dprMainMKItems}
onChange={(e) => setDprMainMK(e.value)}
placeholder={select_a_department_holder}
/>
        </div>
              </div>
             
              <div className="col-span-1">
              <div>
              <Dropdown
className="h-11 w-24 rounded-md" // Bu satır eklenmiştir
style={{ width: '100%' }}
dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
<path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
</svg>}
value={dprSubMK}
options={dprSubKItems}
onChange={(e) => setDprSubMK(e.value)}
placeholder={select_a_department_holder}
/>
        </div>     
        </div>

</div>
<Divider/>

</div>
</div>

     
        

      </TabPanel>
      </TabView>
     
          </div>

          

          

   

      <div className="col-span-1 ml-40">

      <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTabR} onTabChange={(e) => handleTabChangeR(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabR === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Stay Information"}
            </span>
          }
          className="ml-5 flex"
        >
       
        <div className="grid mt-3 grid-cols-2 gap-4">
          <div className="col-span-1">
            <label className="block font-bold mb-1">Check-In</label>
            <Calendar className="w-full h-11" 
              id="firmname" 
              value={startDate} 
              dateFormat="dd/mm/yy"
              onChange={(e) => setStartDate(e.target.value)} 
              locale="tr"
            />
          </div>
          <div className="col-span-1">
            <label className="block font-bold mb-1">Check-Out</label>
            <Calendar className="w-full h-11" 
              id="firmname" 
              value={endDate} 
              dateFormat="dd/mm/yy"
              onChange={(e) => setEndDate(e.target.value)} 
              locale="tr"
            />
          </div>
          <div className="col-span-2">
            
            <div className="flex space-x-2">
            <div>    

<label className=" block font-bold mb-1 text-gray-950 justify-content-center gap-4"
htmlFor="username">  {"Pax"}</label>
<InputText className="w-full" 
id="adult" value={resAccomGuest}

/></div> 
     

       <div>    

<label className=" block font-bold mb-1 text-gray-950 justify-content-center gap-4"
htmlFor="username">  {"Adult"}</label>
<InputText className="w-full" 
id="adult" value={totalAdl}

/></div> 

<div>    

<label className="block font-bold mb-1 text-gray-950 justify-content-center gap-4"
htmlFor="username">  {"Child"}</label>
<InputText className="w-full" 
id="adult" value={totalChl}

/></div> 

       
          
            </div>
          </div>
          <div className="col-span-1">
            <label className="block font-bold mb-1">Nights</label>
            <InputText className="w-full" placeholder="2" />
          </div>
          <div className="col-span-1">
            <div className="w-1/1 gap-3">
              <label className="block font-bold mb-1">Room</label>
              <InputText className="w-full" id="username" value={resAccomRoom} onChange={(e) => setResAccomRoom(e.target.value)} />
            </div>
          </div>
          <div className="col-span-1">
            <label className="block font-bold mb-1">Resev. Type</label>
            <div>
            <div className=" w-full rounded-md border p-2">
                {resTypeSelect.find(option => option.value === resType)?.label || position}
            </div>
            <input 
                type="hidden" 
                value={resType} 
                onChange={handleChange(setResType)} 
            />
        </div>
          </div>
          <div className="col-span-1">
            <label className="block font-bold mb-1">Release Date</label>
            <Calendar className="w-full" placeholder="15th May 2019" />
          </div>
        </div>
        

      </TabPanel>

      <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabR === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Room"}
            </span>
          }
          className="ml-5 flex"
        >
     

     <DataTable
      value={firmData2}
      scrollable 
      scrollHeight="450px" 
      loading={loadingRuleSub}
      stickyHeader
      stickyTopAt=".layout-topbar"
    >
      <Column 
        field="room_type"
        className="text-xs text-right" 
        header={<span className="font-bold text-gray-900">{"Type"}</span>}
        style={{ textAlign: 'left', width: '9rem' }}
      />
      <Column 
        field="get_room_name.r_type_name"
        className="text-xs text-right" 
        header={<span className="font-bold text-gray-900">{"Room Name"}</span>}
        style={{ textAlign: 'left', width: '15rem' }}
      />
      <Column 
        field="person_adl"
        className="text-xs text-right" 
        header={<span className="font-bold text-gray-900">{"Adl"}</span>}
        footer={<span className="font-bold text-gray-900">{`Adl: ${totalAdl}`}</span>}
        style={{ textAlign: 'left', width: '7rem' }}
        footerStyle={{ backgroundColor: '#f0f0f0', color: '#333' }} 
        
      />
      <Column 
        field="person_chl"
        className="text-xs text-right" 
        header={<span className="font-bold text-gray-900">{"Chl"}</span>}
        footer={<span className="font-bold text-gray-900">{`Chl: ${totalChl}`}</span>}
        style={{ textAlign: 'left', width: '7rem' }}
        footerStyle={{ backgroundColor: '#f0f0f0', color: '#333' }} 
      
      />
    </DataTable>
        

      </TabPanel>
      </TabView>
      
      </div>
    
        </div>





      <Divider  className="mt-10" />

          <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTabS} onTabChange={(e) => handleTabChangeS(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"General Information"}
            </span>
          }
          className="ml-5 flex"
        >
   

      </TabPanel>

      <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Event & Meeting"}
            </span>
          }
          className="ml-5 flex"
        >
   

      </TabPanel>
      <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Spa & Services"}
            </span>
          }
          className="ml-5 flex"
        >
   

      </TabPanel>
      <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Invoice & Payments"}
            </span>
          }
          className="ml-5 flex"
        >
   

      </TabPanel>

      <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Task"}
            </span>
          }
          className="ml-5 flex"
        >
   

      </TabPanel>
</TabView>

     

        <div className="border-t mt-4 pt-4 grid grid-cols-3 gap-4">
          <div className="col-span-2">
            <div className="flex items-center">
              <Checkbox className="mr-2" />
              <label className="block font-bold">Task</label>
            </div>
          </div>
          <div className="col-span-1">
            <h3 className="text-lg font-bold mb-2">Summary</h3>
            <div className="grid grid-cols-1 gap-2">
              <div className="flex justify-between">
                <span>Room Charges</span>
                <span>{totals.basePrice.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Discount</span>
                <span>{totals.discounts.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Tax</span>
                <span>{totals.additionalTaxes.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span>Extra Charge</span>
                <span>0</span>
              </div>
              <div className="flex justify-between">
                <span>Unposted Inclusion Rate</span>
                <span>0</span>
              </div>
              <div className="flex justify-between">
                <span>Amount Paid</span>
                <span>0</span>
              </div>
              <div className="flex justify-between">
                <span>Round off</span>
                <span>0</span>
              </div>
              <div className="flex justify-between font-bold">
                <span>Total</span>
                <span className="text-red-500">{totals.finalPrice.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end mt-4 pt-4 border-t">
          <Button label="Cancel" className="p-button-text p-mr-2" />
          <Button label="Save" className="p-button-primary" />
        </div>
      </div>
    </div>

  </div>
 
);
};

export default HtlResAboutDltInfo;
/*


            <h3 className="text-lg font-bold mb-2">Guest Information</h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-1">

                <label className="block font-bold mb-1">Name</label>
                <InputText className="w-full" placeholder="Mr." />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">{dprMainMK}</label>
                <InputText className="w-full" placeholder="First Name" />
              </div>
              <div className="col-span-1">
                
              </div>
              <div className="col-span-2">
                <InputText className="w-full" placeholder="Last Name" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Email</label>
                <InputText className="w-full" placeholder="name@gmail.com" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Phone</label>
                <InputText className="w-full" placeholder="0123 456 789" />
              </div>
            
              <div className="col-span-2">
                <label className="block font-bold mb-1">DOB</label>
                <Calendar className="w-full" placeholder="15th May 2019" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">Nationality</label>
                <Dropdown className="w-full" options={nationalityOptions} placeholder="Select a Nationality" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">Guest Category</label>
                <Dropdown className="w-full" options={guestCategoryOptions} placeholder="Select a Category" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">ID Type</label>
                <Dropdown className="w-full" options={idTypeOptions} placeholder="Select an ID Type" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">ID No.</label>
                <InputText className="w-full" placeholder="3456789" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">Expiry Date</label>
                <Calendar className="w-full" placeholder="17th May 2022" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">Upload ID</label>
                <InputText className="w-full" placeholder="BD_3456789.jpg" />
              </div>
              <div className="col-span-2">
                <Button label="Add Details" className="p-button-link" />
              </div>
            </div>





               

        <div className="border-t mt-4 pt-4 grid grid-cols-1 gap-4">
          <div className="col-span-2">
            <h3 className="text-lg font-bold mb-2">General Information</h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-1">
                <label className="block font-bold mb-1">Source/Reference</label>
                <Dropdown className="w-full" placeholder="--Select--" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Purpose</label>
                <Dropdown className="w-full" options={purposeOptions} placeholder="Guest" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Bill To</label>
                <Dropdown className="w-full" placeholder="Guest" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Type</label>
                <Dropdown className="w-full" options={typeOptions} placeholder="Cash" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Payment Method</label>
                <Dropdown className="w-full" options={paymentMethodOptions} placeholder="Credit Card" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Advance Amount</label>
                <InputText className="w-full" placeholder="10,000" />
              </div>
              <div className="col-span-2">
                <label className="block font-bold mb-1">Payment Note</label>
                <InputText className="w-full" placeholder="Payment..." />
              </div>
            </div>
          </div>

          <div className="col-span-1">
            <h3 className="text-lg font-bold mb-2">Special Instruction</h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-1">
                <label className="block font-bold mb-1">Department</label>
                <InputText className="w-full" placeholder="HK" />
              </div>
              <div className="col-span-1">
                <label className="block font-bold mb-1">Description</label>
                <InputText className="w-full" placeholder="Guest needs The Holly Quran..." />
              </div>
              <div className="col-span-2">
                <Button label="+" className="p-button-rounded p-button-primary" />
              </div>
            </div>
          </div>
        </div>

            */